export const getUuidV4 = () => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c == 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

export const getDatetimeGreenwich = () => {
	const date = new Date();

	// returns UTC (=GMT) Hour of the date
	const hour = date.getUTCHours();

	// returns UTC (=GMT) Minutes of the date
	const minute = date.getUTCMinutes();

	// returns UTC (=GMT) Seconds of the date
	const seconds = date.getUTCSeconds();

	// returns UTC (=GMT) year of the date
	const year = date.getUTCFullYear();

	// returns UTC (=GMT) month (0-11)
	//    0 is January, 11 is December
	const month = date.getUTCMonth();

	// returns UTC (=GMT) day of the month (1-31)
	const day = date.getUTCDate();

	return `${year}-${month + 1}-${day} ${hour}:${minute}:${seconds}`;
};

export const getHitId = () => {
	const now = new Date();
	const tzo = -now.getTimezoneOffset();
	const dif = tzo >= 0 ? '+' : '-';
	const pad = function (num: number) {
		const norm = Math.abs(Math.floor(num));
		return (norm < 10 ? '0' : '') + norm;
	};
	return (
		now.getFullYear() +
		'-' +
		pad(now.getMonth() + 1) +
		'-' +
		pad(now.getDate()) +
		'T' +
		pad(now.getHours()) +
		':' +
		pad(now.getMinutes()) +
		':' +
		pad(now.getSeconds()) +
		'.' +
		pad(now.getMilliseconds()) +
		dif +
		pad(tzo / 60) +
		':' +
		pad(tzo % 60)
	);
};
